import React from 'react';
//IMPORTS MATERIAL UI
import Fab from '@material-ui/core/Fab';
import AddIcon from '@material-ui/icons/Add';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import TextField from '@material-ui/core/TextField';
import { makeStyles } from '@material-ui/core/styles';
//IMPORTS COMPONENTS DATE & SELECT
import DateComponent from './dateComponent'
import SelectComponent from './selectComponent'
//NOTIFICATIONS
import AddAlert from "@material-ui/icons/AddAlert";
import Snackbar from "./Snackbar.js";
//CREATE STYLES
const useStyles = makeStyles(theme => ({
  textField: {
    marginLeft: theme.spacing(0),
    marginRight: theme.spacing(0),
  },
}));

export default function FormDialog(props) {

  const [open, setOpen] = React.useState(false)//MODAL STATE
  const data = props.data//DATAFIELDS
  const labels = labelsForm()//LABELS TO PUT IN FORM
  const fk = props.fk//ARRAY FOREIGN KEYS
  const fkEntity = props.fkEntity//OBJECT FOREIGN KEYS DATA

  if(fkEntity!=null){
    console.log(fkEntity[0])
  }
  var cont = 0 //COUNTER FOR CREATE SEVERAL SELECT OPTIONS COMPONENT
  const classes = useStyles();
  //NOTIFICATION COMPONENT
  const [tc, setTC] = React.useState(false);
      const showNotification = () => {
              alert('Entra')
              console.log(tc)
              setTC(true);
              console.log(tc)
              // setTimeout(function() {
              //   setTC(false);
              //   console.log(tc)
              // }, 2000);
    }

    function labelsForm(){//BUILD OBJECT WITH NAME & TYPE OF FOREIGN KEYS, ALSO WITH NAME & TYPE OF LABELS FORM DATAFIELDS
    var label = {
      'label':[]
    }    
    data.map((element) =>{ //CHECK DATAFIELDS
      if(fk && (fk.includes(element.name))){ //COMPARE ARRAY FOREIGN KEYS AND DATAFIELDS FR CREATE LABELS FOR SLECT COMPONENT
        label.label.push({
          'name':element.name,
          'type':element.type
        })
      }
      if(element.form == true){ //CREATE LABELS FOR NORMAL INPUT COMPONENT
        label.label.push({
          'name':element.name,
          'type':element.type
        })
      }
    })
    return label.label
  }

  function handleClickOpen() {//OPEN MODAL
    setOpen(true);
  }

  function createInsertForm(name, type, required, form){//CREATE FORM
    if (form==true){
    switch(type){
      case 'date':
        return(
          <DateComponent //CREATE DATE COMPONENT 
          key={name} //KEY FOR NEW COMPONENT
          id={name} //ID FOR GET VALUE
          label={getLabel(name)} //LABEL FOR COMPONENT
          name={name}/> //NAME FOR COMPONENT
        )
      case 'number':
        return (
          <TextField //CREATE NUMBER COMPONENT IN FORM
            key={name} //KEY FOR NEW COMPONENT
            className={classes.textField} //THEME FOR COMPONENT
            autoFocus //ANIMATION FOR COMPONENT
            margin={'normal'} //MARGIN TYPE
            InputLabelProps={{shrink: true,}} //PROPS FOR LABEL 
            variant={'outlined'} //VARIANT TO USE
            id={name} //ID FOR GET VALUE
            type={type} //TEXTFIELD TYPE
            name={name} //TEXTFIELD NAME
            required={required} //TEXTFIELD REQUIRED
            label={getLabel(name)} //LABEL FOR COMPONENT
            fullWidth/>
            )
      case 'text':
        return (
          <TextField //CREATE TEXT COMPONENT IN FORM
            key={name} //KEY FOR NEW COMPONENT
            className={classes.textField} //THEME
            autoFocus //ANIMATION
            margin={'normal'} //MARGIN TYPE
            InputLabelProps={{shrink: true,}} //PROPS FOR LABEL
            variant={'outlined'} //VARIAN TO USE
            id={name} //ID FOR GET VALUE
            type={type} //TEXTFIELS TYPE
            name={name} //TEXTFIELD NAME
            required={required} //TEXTFIELD REQUIRED
            label={getLabel(name)} //LABEL FOR COMPONENT
            fullWidth/>
            )
      }
    }
  }

  function getLabel(datafield){//GET LABEL FOR INPUTS
    return datafield.toUpperCase()
  }

  function handleClose() {//CLOSE MODAL
    setOpen(false);
  }
  
  function getDate() {
    let date =  new Date()
    let anio = date.getFullYear()
    let mes = date.getMonth()+1
    let dia = date.getDate()
    if(dia<9){
      dia='0'+dia
    }
    date = anio + '-' + mes + '-' + dia
    console.log(date)
    return date
  }

  function buildBody(){//BUIL BODY REQUEST
    var data = new Object() //OBJECT TO SAVE ALL DATA
    var keyData = new Object() //OBJECT TO SAVE KEY DATA & VALUE
    var i = 0 //COUNTER FOR INPECT EVERY POSITION IN OBJECT
    props.data.map((element)=>{ //CHECK LABELS OBJECT //PARCHE (PROPS.DATA => LABELS)
      if(element.form == true){
      var type = element.type //GET TYPE FOR EVERY COMPONENT
      switch(type){
        case 'number': //GET COMPONENT VALUE IN EVERY ID AND TRANSFORM DATATYPE
          keyData[element.name] = Number(document.getElementById(labels[i].name).value)
          break
        case 'text': //GET COMPONENT VALUE IN EVERY ID AND TRANSFORM DATATYPE
          keyData[element.name] = String(document.getElementById(labels[i].name).value)
          break
        case 'date'://GET COMPONENT VALUE IN EVERY ID AND BUILD FORMAT DATE
          let value = document.getElementById(labels[i].name).value
          const [anio, mes, dia] = value.split('/')
          const date  = [anio, '-', mes, '-', dia].join('');
          //BUILD ALL DATA FOR REQUEST
          keyData[element.name] = String(date)
          break
      }
      i++}
      if(element.name=='active'){
        keyData[element.name]=true
        }else if(element.name=='created_on' || element.name=='updated_on'){
        keyData[element.name]=getDate()
        }else if(element.name=='created_by' || element.name=='updated_by'){
        keyData[element.name]='System'            
        }//END PARCHE
    })
    // keyData[props.id]=state.id
    //BUILD FINAL BODY
    // data[deleteLastCharacter(props.record)]=keyData
    data[props.record]=keyData
    // setState({ ...state, [props.id]: '' })
    //RETURN BODY
    return data
  }

  function post(e){//SEND POST REQUEST
    var body = buildBody()//GET BODY REQUEST
    e.preventDefault()
    console.log(JSON.stringify(body))
    var xhr = new XMLHttpRequest();
    xhr.open('POST', props.host+props.entity, true);
    //Send the proper header information along with the request
    xhr.setRequestHeader('Content-type', 'application/json; charset=UTF-8')
    xhr.send(JSON.stringify(body));
    xhr.onreadystatechange = function() { // Call a function when the state changes.
        if (this.readyState === XMLHttpRequest.DONE && this.status === 200) {
            // showNotification()
            alert('A new element has been added')
            props.onClick(true)
        }else{
          console.log('Error during insert')
        }
    }
    handleClose()
  }

  function createComboBox(element){//CREATE COMBO BOX COMPONENT WITH FOREIGN KEYS
    cont++
    return(
      <SelectComponent 
      key={fk[cont-1].name+cont} //KEY FOR NEW COMPONENT
      name={fk[cont-1].name} //NAME
      label={getLabel(fk[cont-1].name)} //LABEL FOR COMPONENT
      items={element}/> //ITEMS OPTIONS IN SELECT COMPONENT
      
    )
  }

if(fkEntity!=null){// CREATE FORM WITH FOREIGN KEYS COMPONENTS
  return (
    <div align={'right'}>
      <Fab size={'small'} color="secondary" aria-label="add" onClick={handleClickOpen}>
        <AddIcon />
      </Fab>
      <Dialog open={open} onClose={handleClose} aria-labelledby="form-dialog-title">
        <DialogTitle >NEW {getLabel(props.record)}</DialogTitle>        
        <form className={'commentForm'} onSubmit={post} method={'POST'}>
        <DialogContent align={'left'}>
          {/**Create comboBox by Foreign keys */}
          {fkEntity.map((element)=>
            createComboBox(element)
          )}
          {/**create inputs */}
          {data.map((element) =>
            createInsertForm(element.name, element.type, element.required, element.form)
          )}
        </DialogContent>
        <DialogActions>
          <Button variant={'contained'} onClick={handleClose} color={'secondary'}>
            Cancel
          </Button>
          <Button variant={'contained'} type={'submit'} color={'primary'}>
            Done
          </Button>
        </DialogActions>        
        </form>
      </Dialog>
      <Snackbar
        place="tc"
        color="success"
        icon={AddAlert}
        message="Welcome to MATERIAL DASHBOARD PRO - a beautiful admin panel for every web developer"
        open={tc}
        closeNotification={() => setTC(false)}
        close
      />
    </div>
  )
}else{//CREATE NORMAL FORM
  return (
    <div align={'right'}>
      <Fab size={'small'} color="secondary" aria-label="add" onClick={handleClickOpen}>
        <AddIcon />
      </Fab>
      <Dialog open={open} onClose={handleClose} aria-labelledby="form-dialog-title">
        <DialogTitle >NEW {getLabel(props.record)}</DialogTitle>        
        <form className={'commentForm'} onSubmit={post} method={'POST'}>
        <DialogContent align={'left'}>
          {data.map((element) =>
            createInsertForm(element.name, element.type, element.required, element.form)
          )}
        </DialogContent>
        <DialogActions>
          <Button variant={'contained'} onClick={handleClose} color={'secondary'}>
            Cancel
          </Button>
          <Button variant={'contained'} type={'submit'} color={'primary'}>
            Done
          </Button>
        </DialogActions>        
        </form>
      </Dialog>
      <Snackbar
        place="tc"
        color="success"  
        icon={AddAlert}  
        message="Welcome to MATERIAL DASHBOARD PRO - a beautiful admin panel for every web developer"
        open={tc}
        closeNotification={() => setTC(false)}
        close
      />
    </div>
  )
}
}